var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 41,
    viewBox: "0 0 50 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2857 36.5979C42.3627 36.5979 44.8572 34.1035 44.8572 31.0265C44.8572 27.9495 42.3627 25.4551 39.2857 25.4551C36.2087 25.4551 33.7143 27.9495 33.7143 31.0265C33.7143 34.1035 36.2087 36.5979 39.2857 36.5979Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 8.88672H32.8125C34.4701 8.88672 36.0598 9.42173 37.2319 10.3741C38.404 11.3264 39.0625 12.618 39.0625 13.9648C39.0625 15.3116 38.404 16.6033 37.2319 17.5556C36.0598 18.508 34.4701 19.043 32.8125 19.043H14.0625C11.9905 19.043 10.0034 19.7117 8.53823 20.9022C7.0731 22.0926 6.25 23.7071 6.25 25.3906C6.25 27.0741 7.0731 28.6887 8.53823 29.8791C10.0034 31.0695 11.9905 31.7383 14.0625 31.7383H24.2188H32.8125",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPath);
export default __webpack_public_path__ + "static/media/icon-path.902340a63a57dd475db118348c1f50fa.svg";
export { ForwardRef as ReactComponent };